import React, { useEffect, useState } from 'react';
import apiClient from '../api';
import {
    Box, Typography, Table, TableHead, TableBody, TableRow, TableCell,
    Chip, CircularProgress, Alert,
} from '@mui/material';
import moment from 'jalali-moment';
import { formatToman } from '../labels';
import { glass } from '../theme';

function AdminContracts() {
    const [contracts, setContracts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        apiClient.get('/api/admin-panel/contracts/')
            .then((res) => setContracts(res.data))
            .catch(() => setError('خطا در دریافت لیست قراردادها.'))
            .finally(() => setLoading(false));
    }, []);

    if (loading) {
        return <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}><CircularProgress /></Box>;
    }

    return (
        <Box>
            <Typography variant="h4" sx={{ fontWeight: 800, mb: 0.5 }}>قراردادها</Typography>
            <Typography color="text.secondary" sx={{ mb: 2 }}>
                وضعیت پذیرش قرارداد توسط دو طرف، برای هر درخواستی که پیشنهادی پذیرفته شده.
            </Typography>
            {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

            <Box sx={{ ...glass.card, overflow: 'auto' }}>
                <Table size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell>شماره قرارداد</TableCell>
                            <TableCell>درخواست</TableCell>
                            <TableCell>درخواست‌دهنده</TableCell>
                            <TableCell>همیار</TableCell>
                            <TableCell>مبلغ</TableCell>
                            <TableCell>پذیرش درخواست‌دهنده</TableCell>
                            <TableCell>پذیرش همیار</TableCell>
                            <TableCell>وضعیت</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {contracts.map((c) => (
                            <TableRow key={c.id} hover>
                                <TableCell>#{c.id}</TableCell>
                                <TableCell>#{c.request}</TableCell>
                                <TableCell>{c.requester_name}</TableCell>
                                <TableCell>{c.provider_name}</TableCell>
                                <TableCell>{formatToman(c.amount)}</TableCell>
                                <TableCell>{c.requester_accepted_at ? moment(c.requester_accepted_at).locale('fa').format('D MMM YYYY') : '—'}</TableCell>
                                <TableCell>{c.provider_accepted_at ? moment(c.provider_accepted_at).locale('fa').format('D MMM YYYY') : '—'}</TableCell>
                                <TableCell>
                                    <Chip
                                        size="small"
                                        label={c.is_fully_signed ? 'تکمیل شده' : 'در انتظار امضا'}
                                        color={c.is_fully_signed ? 'success' : 'warning'}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Box>
        </Box>
    );
}

export default AdminContracts;
